import HeaderDescription from "../components/HeaderDescription";
import ProfileHeaderSection from "../components/ProfileHeaderSection";
import { FowardButton, BackButton } from "../components/forms/DashboardButton";
import HeaderBox from "../components/Box/HeaderBox";

import Screen from "../components/Screen";
import { useNavigate } from "react-router-dom";
import UnionSet from "../components/UnionSet";
import { useGetQuarterlyGoals } from "../hooks/useGoals";
import { useState } from "react";

const Quarterly = () => {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate("/annual-goals");
  };

  const handlePrev = () => {
    navigate("/true-north");
  };

  const [quarter, setQuarter] = useState("Q1");

  const { goals, isPending } = useGetQuarterlyGoals(quarter);

  const hospital = goals?.[0]?.hospital ?? 0;
  const revenue = goals?.[0]?.reveune ?? 0;
  const spent = goals?.[0]?.spent ?? 0;
  return (
    <div className="bg-white w-full">
      <Screen>
        <ProfileHeaderSection />
        <HeaderDescription
          maintext={"Dashboard"}
          subtext={"Our Team"}
          subsubtext={"Quarterly Goals"}
        />
        <p className={` text-4xl text-lightDark my-4`}>Quarterly Goals</p>
        <div className="">
          <HeaderBox text="Our Quarterly Goals" />
        </div>
        <div className={` text-black  mt-4 text-basetext leading-7 text-left`}>
          Here are our goals for 2024. We can achieve these if we all work hard
          and give our best! Let’s go!
        </div>

        <div className="w-full flex flex-col lg:flex-row justify-between lg:h-96 h-screen rounded mt-4 bg-orange gap-2">
          <div className="lg:w-6/12  px-2 py-4 h-5/6 flex flex-col justify-center ">
            <p className={`text-black text-3xl mb-4 `}>
              The <span className={`text-lightRed text-2xl `}>Market</span>
            </p>
            <div>
              <p className={`text-black  text-basetext leading-7`}>
                For quarterly revenue estimation, we use the number of hospitals
                and their average spend from the annual goal. This method
                provides insight into our potential quarterly performance.
              </p>
            </div>
          </div>
          <div className="lg:w-6/12 flex flex-col md:flex-row md:items-start md:justify-center h-full p-2">
            <select
              name=""
              id=""
              className="bg-transparent border rounded-md p-2"
              value={quarter}
              onChange={(e) => setQuarter(e.target.value)}
            >
              <option value="Q1">Q1</option>
              <option value="Q2">Q2</option>
              <option value="Q3">Q3</option>
              <option value="Q4">Q4</option>
            </select>
            <div className="flex items-center h-2/5 justify-center">
              <UnionSet
                hospital={hospital}
                spent={spent}
                revenue={revenue}
                loading={isPending}
              />
            </div>
          </div>
        </div>
        <div className="my-4 flex gap-2 justify-end">
          <BackButton
            text={"Previous"}
            onClick={handlePrev}
            subText={"True North"}
          />

          <FowardButton
            text={"Next"}
            onClick={handleNext}
            subText={"Annual Goals"}
          />
        </div>
      </Screen>
    </div>
  );
};

export default Quarterly;
